export default __webpack_public_path__ + "static/media/listIcon.0cf2d9fe.svg";